import { observer } from "mobx-react-lite";
import React, { RefObject, useMemo, useRef } from "react";
import { classNames } from "src/common/classNames";
import styles from "./ATVFreezeLine.module.less";

/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-static-element-interactions: "off" */

type TypeCell = {
  key: string;
  content: React.ReactNode;
};

export type PropsATVFreezeLine = {
  cells: TypeCell[];
  fixedLeftCount: number;
  inScroll: boolean;
  className?: string;
  onClick?: () => void;
};

export const ATVFreezeLine = observer(
  ({
    cells,
    className,
    fixedLeftCount,
    inScroll,
    onClick,
  }: PropsATVFreezeLine) => {
    const columnRefs = useRef<Record<string, RefObject<HTMLDivElement>>>(
      Object.fromEntries(
        cells.map((cell) => [cell.key, React.createRef<HTMLDivElement>()]),
      ),
    );
    let accumulatedOffset = 0;
    const cellElements = useMemo(
      () =>
        cells.map((cell, index) => {
          const ref = columnRefs.current[cell.key];
          const width = ref?.current?.offsetWidth ?? 0;
          const isFrozen = index < fixedLeftCount;
          const isLast = index === fixedLeftCount - 1;
          const output = (
            <div
              key={cell.key}
              ref={columnRefs.current[cell.key]}
              className={classNames([
                styles.item,
                [isLast && inScroll, styles.last],
              ])}
              style={
                isFrozen ? { left: accumulatedOffset, zIndex: 2 } : undefined
              }
            >
              {cell.content}
            </div>
          );
          accumulatedOffset += isFrozen ? width : 0;
          return output;
        }),
      [cells, fixedLeftCount],
    );
    return (
      <div className={className} onClick={onClick}>
        {cellElements}
      </div>
    );
  },
);
